import React from "react";
import { useTranslation } from "react-i18next";
import { Footer } from "@components/Footer";
import { ReasonsList } from "@components/ReasonsList";
import { FAQSection } from "@components/FAQSection";
import { Hero } from "@components/Hero";
import { Header } from "@components/Header";

/**
 * Home Version Black Friday component
 *
 * Special promotional version for Black Friday campaign.
 * Uses the same structure as Version A but with Black Friday promotional copy.
 * Features $40 reward messaging in the hero section.
 *
 * @returns {JSX.Element} The Black Friday promotional home page
 */
export function HomeVersionBlackFriday() {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col items-center font-sans">
      <div
        className="w-full flex flex-col items-center font-sans"
        style={{
          background: "linear-gradient(180deg, #FCFCFD 0%, #E3E8EF 100%)",
        }}
      >
        <Header />

        {/* Hero - Black Friday promotional copy */}
        <Hero
          title={t("versionBlackFriday.hero.title")}
          description={t("versionBlackFriday.hero.description")}
          buttonText={t("versionBlackFriday.hero.buttonText")}
          imageSrc="/images/screen-meet-pharmacist.png"
          imageAlt={t("versionBlackFriday.hero.imageAlt")}
          appleButtonSrc="/images/app-store-white.png"
          googleButtonSrc="/images/play-store-white.png"
        />
      </div>

      {/* FAQ Section - Black Friday copy */}
      {/* <FAQSection
        title={t("versionBlackFriday.faq.title")}
        description={t("versionBlackFriday.faq.description")}
        questionsAndAnswers={[
          t("versionBlackFriday.faq.questions.1"),
          t("versionBlackFriday.faq.questions.2"),
          t("versionBlackFriday.faq.questions.3"),
          t("versionBlackFriday.faq.questions.4"),
          t("versionBlackFriday.faq.questions.5"),
        ]}
      /> */}

      {/* Reasons Section - Black Friday copy */}
      <ReasonsList
        title={t("versionBlackFriday.reasons.title")}
        reasons={[
          t("versionBlackFriday.reasons.list.1"),
          t("versionBlackFriday.reasons.list.2"),
          t("versionBlackFriday.reasons.list.3"),
          t("versionBlackFriday.reasons.list.4"),
        ]}
        imageSrc="/images/screen-home-goal.png"
        imageAlt={t("versionBlackFriday.reasons.imageAlt")}
        buttonText={t("versionBlackFriday.reasons.buttonText")}
      />

      <Footer
        appleButtonSrc="/images/app-store-dark-old.svg"
        googleButtonSrc="/images/play-store-dark-old.svg"
      />
    </div>
  );
}
